import { combineReducers } from 'redux'

import auth from './auth'
import club from './club'
import members from './members'
import courses from './courses'
import instructors from './instructors'
import receipts from './receipts'
import balance from './balance'
import fiscalyear from './fiscalyear'
import attendances from './attendances'
import dashboard from './dashboard'
import notes from './notes'

const rootReducer = combineReducers({
  auth,
  club,
  members,
  courses,
  instructors,
  receipts,
  balance,
  fiscalyear,
  attendances,
  dashboard,
  notes
})

export default rootReducer



// WEBPACK FOOTER //
// ./src/reducers/index.js